"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Assets = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// Оставьте эту строку, чтобы отключить предупреждение eslint
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_1 = require("react");
const uuid_1 = require("uuid");
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const asset_skeleton_1 = require("../../../components/skeletons/asset-skeleton");
const asset_item_1 = require("./asset-item");
const svg_selector_1 = require("../../../assets/svg-selector");
const assets_module_css_1 = __importDefault(require("./assets.module.css"));
const useLoadUserData_1 = require("../../../hooks/useLoadUserData");
const Assets = (props) => {
    const TgObj = sdk_1.default;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { getJettons } = (0, useLoadUserData_1.useLoadUserData)();
    const [searchInput, setSearchInput] = (0, react_1.useState)('');
    const topTokens = ['TON', 'DFC', 'ARBUZ', 'KINGY', 'PRIVATE'];
    const sortedTokensData = [...(props?.tokensData ?? [])];
    console.log('sortedTokensDatasortedTokensDatasortedTokensData', sortedTokensData);
    sortedTokensData.sort((a, b) => {
        const amountA = parseFloat(a?.amountUSD ?? '0');
        const amountB = parseFloat(b?.amountUSD ?? '0');
        const aIsTopToken = topTokens.includes(a.token);
        const bIsTopToken = topTokens.includes(b.token);
        if (aIsTopToken && bIsTopToken) {
            return topTokens.indexOf(a.token) - topTokens.indexOf(b.token);
        }
        if (aIsTopToken) {
            return -1;
        }
        if (bIsTopToken) {
            return 1;
        }
        return amountB - amountA;
    });
    const filteredTokensData = sortedTokensData.filter(el => el.token.toLowerCase().includes(searchInput.toLowerCase()));
    return ((0, jsx_runtime_1.jsxs)("div", { className: assets_module_css_1.default.assets, children: [(0, jsx_runtime_1.jsxs)("div", { className: assets_module_css_1.default.assetsSearch, children: [(0, jsx_runtime_1.jsx)("div", { className: assets_module_css_1.default.assetsSearchIcon, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "search" }) }), (0, jsx_runtime_1.jsx)("input", { type: "text", className: assets_module_css_1.default.assetsSearchInput, placeholder: t('common.search'), value: searchInput, onChange: e => setSearchInput(e.target.value) }), searchInput.length >= 1 && ((0, jsx_runtime_1.jsx)("div", { className: assets_module_css_1.default.assetsClearIcon, onClick: () => {
                            TgObj.HapticFeedback.impactOccurred('medium');
                            setSearchInput('');
                        }, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "clear" }) }))] }), props.tokensLoading ? (new Array(4).fill(null).map(_ => (0, jsx_runtime_1.jsx)(asset_skeleton_1.AssetSkeleton, {}, (0, uuid_1.v1)()))) : !filteredTokensData || filteredTokensData?.length >= 1 ? (filteredTokensData?.map(el => ((0, jsx_runtime_1.jsx)(asset_item_1.AssetItem, { priceUSD: el.priceUSD || '0', diff: el.priceDiff || '', token: el.token, tokenLogo: el.tokenLogo, amount: el.amount, amountUSD: el.amountUSD || '', setShowJettonDetail: props.setShowJettonDetail, setJettonDetailData: props.setJettonDetailData, tokenAddress: el.tokenAddress[0] }, (0, uuid_1.v1)())))) : ((0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: assets_module_css_1.default.notFound, children: t('common.not-found') }))] }));
};
exports.Assets = Assets;
